module.exports = __webpack_public_path__ + "media/images/page/photo_sample-l-a512b4752dbc313076d3f5d067f3fcfd.jpg";